import {
  RyeconFreshnessError,
  RyeconFreshnessPassed,
  RyeconFreshnessStale,
  RyeconFreshnessUnknown,
  RyeconStatusSkipped,
} from '@dbt-labs/sourdough';

import { TileStatus } from '../EnvBased/DataMonitor';

interface StatusIndicatorProps {
  dataStatus: TileStatus;
}

const getIcon = (dataStatus: TileStatus) => {
  const statusIcon = {
    [TileStatus.unknown]: (
      <RyeconFreshnessUnknown size="xl" data-testid="status-unknown" />
    ),
    [TileStatus.pass]: <RyeconFreshnessPassed size="xl" data-testid="status-pass" />,
    [TileStatus.warn]: <RyeconFreshnessStale size="xl" data-testid="status-warn" />,
    [TileStatus.error]: <RyeconFreshnessError size="xl" data-testid="status-error" />,
    [TileStatus.skipped]: (
      <RyeconStatusSkipped size="xl" data-testid="status-skipped" />
    ),
  };

  return statusIcon[dataStatus];
};

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ dataStatus }) => {
  const StatusIcon = getIcon(dataStatus);

  return (
    <div className="mx-auto flex items-center justify-center rounded-full text-center">
      {StatusIcon}
    </div>
  );
};

export default StatusIndicator;
